export const BASE_PATH = 'https://api.metapix.me/enterprise';
export const ENVIRONMENT = process.env.REACT_APP_MODE?.toLowerCase();